import React, { memo, useCallback } from "react";
import PropTypes from "prop-types";
import { WALLET_NAV_ITEMS } from "../../constants";
import { TabButton, TabsLabel, TabsRoot, TabsRow } from "./elements";

const getTabLabel = (item, translate) =>
	item.labelKey ? translate(item.labelKey) : translate(item.label);

export const BettoWalletTabs = memo(({ translate, currentPath, history }) => {
	const handleTabClick = useCallback(
		(link) => {
			if (link !== currentPath) {
				history.push(link);
			}
		},
		[currentPath, history]
	);

	return (
		<TabsRoot aria-label={translate("betto.profile.wallet")}>
			<TabsLabel>{translate("betto.profile.wallet")}</TabsLabel>
			<TabsRow>
				{WALLET_NAV_ITEMS.map((item) => (
					<TabButton
						key={item.key}
						type="button"
						$active={currentPath === item.link}
						data-testid={item.testId}
						onClick={() => handleTabClick(item.link)}>
						{getTabLabel(item, translate)}
					</TabButton>
				))}
			</TabsRow>
		</TabsRoot>
	);
});

BettoWalletTabs.displayName = "BettoWalletTabs";

BettoWalletTabs.propTypes = {
	translate: PropTypes.func.isRequired,
	currentPath: PropTypes.string,
	history: PropTypes.object.isRequired,
};
